import { Button, Form, Offcanvas } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ProductsSelect } from 'modules/product';
import AddComingFormik from "./AddComingFormik";
import ComingTable from "./ComingTable";
import ComingAiPanel from "./ComingAiPanel";
import spinnerTitle from "components/others/spinnerTitle";
import SpinnerBlock from "components/others/SpinnerBlock";
import { ProductSetsSelect } from 'modules/product';
import useOffComing from "./model/useOffComing";
import SolarIcon from 'components/icons/SolarIcon';

const OffComing = ({show, setShow, fetchStocks}: any) => {

    const { t } = useTranslation(['Warehouses', 'common']);
    const {
        rate,
        canCredit,
        addProduct,
        addSet,
        addSourceType,
        setCount,
        setDescription,
        setAddProcess,
        aComing,
        comingProcess,
        aiPricesInUsd,
        aiBusy,
        uploadProgress,
        processingLabel,
        aiPhase,
        refInputFile,
        setSetCount,
        setSetDescription,
        setAiPricesInUsd,
        setAddProduct,
        setAComing,
        handleClickApproved,
        handleChangeProduct,
        handleChangeSet,
        handleSelectType,
        handleCancelSetComing,
        handleAddSetComing,
        handleHide,
        handleOpenClick,
        handleChangeFile,
        handleCancel,
    } = useOffComing({ show, setShow, fetchStocks });

    return (
        <Offcanvas 
            show={show!==false} 
            onHide={handleHide}
            placement="end"
            className="off-import">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('toolComming')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-coming-form d-flex flex-column h-100">
                    <div className="off-coming-content">
                        <div className="mx-3 mb-3 p-3 border rounded off-coming-add-box">
                            <div className="mb-3">
                                <h6 className="mb-0 text-muted">
                                    <SolarIcon name="ui-checks-grid" className="me-2" />
                                    {t('titleAddOperationItem')}
                                </h6>
                            </div>
                            <div className="btn-group w-100 mb-3">
                                <Button
                                    size="sm"
                                    variant={addSourceType === 'product' ? 'primary' : 'outline-primary'}
                                    onClick={() => handleSelectType('product')}
                                    disabled={comingProcess || setAddProcess}
                                >
                                    <SolarIcon name="box-seam" className="me-1" />
                                    {t('labelModeProduct')}
                                </Button>
                                <Button
                                    size="sm"
                                    variant={addSourceType === 'set' ? 'primary' : 'outline-primary'}
                                    onClick={() => handleSelectType('set')}
                                    disabled={comingProcess || setAddProcess}
                                >
                                    <SolarIcon name="collection" className="me-1" />
                                    {t('labelModeSet')}
                                </Button>
                                <Button
                                    size="sm"
                                    variant={addSourceType === 'ai' ? 'light' : 'outline-secondary'}
                                    className={`off-coming-ai-tab ${addSourceType === 'ai' ? 'is-active' : ''}`}
                                    onClick={() => handleSelectType('ai')}
                                    disabled={comingProcess || setAddProcess || aiBusy}
                                >
                                    <SolarIcon name="stars" className="me-1" />
                                    <span className="d-none d-sm-inline">{t('labelModeAi')}</span>
                                    <span className="d-sm-none">{t('labelModeAiShort')}</span>
                                </Button>
                            </div>

                            {addSourceType === 'product' ? (
                                <ProductsSelect
                                    disabled={comingProcess || setAddProcess}
                                    value={addProduct?.value}
                                    autoChangeId={typeof show === 'number' && show > 0 ? show : null}
                                    title={t('labelSetProduct')}
                                    onChange={(opt) => {
                                        handleChangeProduct(opt);
                                    }}
                                /> 
                            ) : addSourceType === 'set' ? (
                                <ProductSetsSelect
                                    disabled={comingProcess || setAddProcess}
                                    value={addSet?.value || null}
                                    title={t('labelSetProductSet')}
                                    onChange={(opt) => {
                                        handleChangeSet(opt);
                                    }}
                                />
                            ) : (
                                <ComingAiPanel
                                    aiPricesInUsd={aiPricesInUsd}
                                    setAiPricesInUsd={setAiPricesInUsd}
                                    aiBusy={aiBusy}
                                    comingProcess={comingProcess}
                                    rate={rate}
                                    handleOpenClick={handleOpenClick}
                                    processingLabel={processingLabel}
                                    aiPhase={aiPhase}
                                    handleCancel={handleCancel}
                                    uploadProgress={uploadProgress}
                                    refInputFile={refInputFile}
                                    handleChangeFile={handleChangeFile}
                                />
                            )}
                            <div className="mt-1">
                                {addProduct ? (
                                    <AddComingFormik
                                        setAddProduct={setAddProduct}
                                        setAComing={setAComing}
                                        cProduct={addProduct}
                                    />
                                ) : addSet && addSourceType === 'set' ? (
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            handleAddSetComing();
                                        }}
                                    >
                                        <Form.Group className="mb-3">
                                            <label className="form-label text-muted">{t('labelCount')}</label>
                                            <input
                                                className="form-control"
                                                required
                                                type="number"
                                                min={1}
                                                step={1}
                                                value={setCount}
                                                disabled={setAddProcess}
                                                onChange={(e) => setSetCount(e.target.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <label className="form-label text-muted">{t('labelDescription')}</label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                value={setDescription}
                                                disabled={setAddProcess}
                                                onChange={(e) => setSetDescription(e.target.value)}
                                            />
                                        </Form.Group>
                                        <div className="d-flex justify-content-end gap-2">
                                            <Button
                                                size="sm"
                                                variant="light"
                                                type="button"
                                                disabled={setAddProcess}
                                                onClick={handleCancelSetComing}
                                            >
                                                {t('buttons.cancel', { ns: 'common' })}
                                            </Button>
                                            <Button size="sm" variant="primary" type="submit" disabled={setAddProcess}>
                                                <SolarIcon name="plus-lg" className="me-1 fs-14" />
                                                {t('btnAdd')}
                                            </Button>
                                        </div>
                                    </Form>
                                ) : null}
                            </div>
                        </div>

                        <SpinnerBlock onlyBlur={true} show={comingProcess} />

                        {!addProduct && !addSet && (
                            <ComingTable
                                comingProcess={comingProcess}
                                aComing={aComing}
                                setAComing={setAComing}
                                showPayment={canCredit}
                            />
                        )}

                        {!(aComing.length > 0) && !addProduct && !addSet && (
                            <div className="alert alert-warning mx-3 mt-3" role="alert">
                                {t('messSelectProduct')}
                            </div>
                        )}
                    </div>

                    <div className="p-3 offcanvas-footer off-coming-footer">
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <p className="small text-muted mb-0 pe-2">
                                {t('comingPriceHint')}
                            </p>
                            <Button
                                variant="info"
                                className="min100px flex-shrink-0"
                                disabled={(addProduct !== null || addSet !== null || comingProcess || aiBusy) || !(aComing?.length > 0)}
                                onClick={handleClickApproved}
                            >
                                {spinnerTitle(
                                    <>
                                        <SolarIcon name="box-arrow-in-down" className="fs-14 me-2" />
                                        {t('btnApproved')}
                                    </>,
                                    comingProcess,
                                    t('btnApproved'),
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas> 
    )
}

export default OffComing;